import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useBreadcrumbs } from '~/composables/useBreadcrumbs';

export default defineNuxtRouteMiddleware(async () => {
  const { clearBreadcrumbs } = useBreadcrumbs();
  clearBreadcrumbs();
});
